<template>
  <div class="container invoice-table">
    <select v-model="selectedMoveType"
            class="custom-select float-left  my-2 my-sm-0"
            :disabled="!isMoveTasksAllowed || moveInProgress"
            style="width: 150px; margin-right: 10px">
      <option value="existingDoc" selected>В другой акт</option>
      <option value="newDoc">В новый акт</option>
    </select>
    <input class="custom-select float-left  my-2 my-sm-0" type="number" style="width: 150px;  margin-right: 10px"
           v-model="newDocId"
           :disabled="!isMoveTasksAllowed || moveInProgress || selectedMoveType !== 'existingDoc'">
    <button
        class="btn my-2 my-sm-0 float-left btn-outline-primary" style="width: 150px; margin-right: 10px"
        @click="moveTasks"
        :disabled="!isMoveTasksAllowed || moveInProgress || (selectedMoveType === 'existingDoc' && !(newDocId && newDocId.length > 0))">
      Переместить
    </button>
    <p v-if="error" class="float-left text-danger" style="margin-top: 8px; margin-left: 6px">
      <strong>{{ error }}</strong>
    </p>
    <br>
    <p>
      <br>
    </p>

    <table class="table table-sm text-left">
      <thead>
      <tr>
        <th><input
            type="checkbox"
            :disabled="moveInProgress"
            v-model="selectAllTasks"
            @change="selectTasksSwitch">
        </th>
        <th>№</th>
        <th>ID</th>
        <th>Shop</th>
        <th>Название</th>
        <th>Создано</th>
        <th>Закрыто</th>
        <th style="width: 120px" class="text-right">Сумма без НДС</th>
        <th style="width: 110px" class="text-right">Сумма c НДС</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(t, i) in tasks"
          :class="{ 'text-color-orange' : t.deleted }">
        <td>
          <input v-if="!t.deleted"
                 :disabled="moveInProgress"
                 type="checkbox"
                 v-model="t.selected">
        </td>
        <td>{{ i + 1 }}</td>
        <td><a :href="t.link" target="_blank">{{ t.external_id }}</a></td>
        <td>{{ t.shop_id }}</td>
        <td>{{ t.name }}</td>
        <td class="text-nowrap">{{ t.time_created }}</td>
        <td class="text-nowrap">{{ t.time_approved }}</td>
        <td class="text-nowrap text-right">{{
            new Intl.NumberFormat('ru-ru', {
              minimumFractionDigits:
                  2
            }).format(t.sum_customer.toFixed(2))
          }}
        </td>
        <td class="text-nowrap text-right">{{
            new Intl.NumberFormat('ru-ru', {
              minimumFractionDigits:
                  2
            }).format(t.amount_with_vat.toFixed(2))
          }}
        </td>
        <td><i v-if="t.deleted" @click="addTask(i, t.id)" class="fas fa-plus-circle cursor-pointer"></i></td>
      </tr>
      </tbody>
    </table>
  </div>

</template>

<script>
import axios from 'axios';

export default {
  name: 'InvoiceTasks',
  data() {
    return {
      doc_id: null,
      newDocId: null,
      tasks: [],
      invoice: null,
      selectAllTasks: false,
      selectedMoveType: "existingDoc",
      error: null,
      moveInProgress: false,
      portalUrl: {
        "ru": "wowworks.ru",
        "by": "wowworks.by",
        "de": "de.wowworks.org",
      },
    };
  },
  computed: {
    isMoveTasksAllowed() {
      let tSearch = this.tasks.find(t => t.selected === true);
      console.log(tSearch);
      return this.$store.getters.isDocEditAllowed && tSearch !== undefined;
    }

  },

  methods: {
    // isDeleted(task) {
    //     return task.deleted;
    // },
    // deleteTask(i, task_id) {
    //
    //     // console.log(this.tasks[i]);
    //
    //     this.tasks[i].deleted = true;
    //     // var t = this.tasks[i];
    //     //
    //     // this.tasks.splice(i, 1);
    //     // this.tasks.unshift(t);
    //     // this.$set(this.tasks[i], 'deleted', true)
    //
    //     axios.delete(`/docs/` + this.doc_id + `/delete_task/` + task_id)
    //         .then((res) => {
    //             console.log(res.data);
    //         })
    //         .catch(error => console.log(error));
    //
    // },
    //
    addTask(i, task_id) {

      // console.log(this.tasks[i]);

      this.tasks[i].deleted = false;
      // var t = this.tasks[i];
      //
      // this.tasks.splice(i, 1);
      // this.tasks.unshift(t);
      // this.$set(this.tasks[i], 'deleted', true)

      axios.put(`/docs/` + this.invoice.id + `/add_task/` + task_id)
          .then((res) => {
            console.log(res.data);
          })
          .catch(error => console.log(error));

    },

    selectTasksSwitch(event) {
      console.log(event);

      this.tasks.forEach(t => {
        if (!t.deleted) {
          t.selected = event.target.checked
        }
      })

    },

    loadTasks() {
      axios.get(`/doc_by_id`, {
        params: {
          invoice_id: this.$route.params.doc_id,
          country_id: this.$route.params.countryID,
        },
      })
          .then((res) => {
            console.log(res.data);
            this.invoice = res.data;

            if (this.invoice.type_id === 1 || this.invoice.type_id === 3 || this.invoice.type_id === 6) {

              axios.get(`/docs/${this.invoice.id}/task_list`)
                  .then((res) => {
                    console.log(res.data);

                    var taskList = res.data;

                    taskList.forEach(t => {
                      t.time_approved = new Date(t.time_approved).toISOString().split("T")[0];
                      t.time_created = new Date(t.time_created).toISOString().split("T")[0];
                      t.selected = false;
                      t.deleted = (t.invoice_id === 0);


                      let sum_customer_cents = Math.round(t.sum_customer * 100);
                      let vat_cents = Math.round(sum_customer_cents * this.invoice.vat_rate);
                      let amount_with_vat = Math.round(sum_customer_cents + vat_cents) / 100;


                      t.amount_with_vat = amount_with_vat;

                      t.link = 'https://curator.' + this.portalUrl[t.country_id] + '/task/' + t.external_id;
                      if (t.type_id === 2) {
                        t.link = 'https://curator.' + this.portalUrl[t.country_id] + '/cleaning/project/' + t.external_project_id + '/object/' + t.external_id + '/calendar';
                      }


                      // t.deleted = false;
                    });

                    this.tasks = taskList;
                  })
                  .catch(error => console.log(error));
            }
          })
          .catch(error => console.log(error));

    },

    // moveTask(task_id) {
    //
    //     axios.put(`/docs/` + this.doc_id + `/move_task/` + task_id, {
    //         newDocId: Number(this.newDocId)
    //     })
    //         .then((res) => {
    //             console.log(res);
    //             this.tasks[i].deleted = true;
    //             this.tasks[i].selected = false;
    //         })
    //         .catch(error => {
    //             console.log(error);
    //             this.error = error.response.data;
    //         });

    // },


    moveTasks() {

      this.moveInProgress = true;

      let tasks = [];
      this.tasks.forEach((t) => {
        if (t.selected && !t.deleted) {
          tasks.push(t.id)
        }
      });

      if (this.newDocId === null) {
        this.newDocId = 0;
      }

      axios.put(`/docs/` + this.invoice.id + `/move_tasks`, {
        tasks: tasks,
        newDocId: Number(this.newDocId)
      })
          .then((res) => {
            // console.log(res);
            // this.tasks.forEach((t, i) => {
            //   if (t.selected) {
            //     this.tasks.splice(i, 1);
            //   }
            // });

            this.loadTasks();

            this.error = "Готово. № " + res.data;

          })
          .catch(error => {
            console.log(error);
            this.error = error.response.data;
          })
          .finally(() => {
            this.moveInProgress = false;
          })
      ;

      // this.tasks.forEach((t, i) => {
      //     if (t.selected) {
      //         this.moveTask(t.id);
      //
      //
      //     }
      // })

    },


  },

  mounted() {
    this.doc_id = this.$route.params.doc_id;
    axios.defaults.headers.authorization = this.$store.state.token;

    this.loadTasks();
  },


}
;
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.invoice-table {
  font-size: 14px;
}

</style>
